import { render, staticRenderFns } from "./Questionnaire.vue?vue&type=template&id=4d482617&scoped=true&"
import script from "./Questionnaire.vue?vue&type=script&lang=js&"
export * from "./Questionnaire.vue?vue&type=script&lang=js&"
import style0 from "./Questionnaire.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Questionnaire.vue?vue&type=style&index=1&id=4d482617&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d482617",
  null
  
)

export default component.exports